import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { Button } from '@tomra/design-system-react/button'
import { Card } from '@tomra/design-system-react/card'

export const SearchPage = () => {
  const navigate = useNavigate()
  const [value, setValue] = useState('')

  const search = (query: any) => {
    if (query.split('-').length === 5 || query.match(/^\w{28}$/g)) {
      navigate(`/user/${query}`)
    } else if (query.match(/^\d{18}$/g)) {
      navigate(`/payout/${query}`)
    } else if (query.match(/^0{1}\d{23}$/g)) {
      navigate(`/bagtag/${query}`)
    } else if (query.match(/^\d{24,25}$/g)) {
      navigate(`/consumersession/${query}`)
    } else {
      navigate(`/users/${query}`)
    }
  }

  return (
    <div className="centerAbsolute w-full max-w-2xl px-6">
      <h1 className="sr-only">Search</h1>
      <Card.Root>
        <Card.Header>
          <Card.Title>Search</Card.Title>
          <Card.Description>Find users, payouts, bags, or sessions</Card.Description>
        </Card.Header>

        <Card.Content>
          <form
            onSubmit={evt => {
              evt.preventDefault()
              search(value)
            }}
          >
            <div className="flex gap-3 items-stretch">
              <input
                type="search"
                className="flex-1 text-base py-3 px-4 border border-gray-300 rounded-lg bg-white shadow-sm 
                           transition-all duration-200
                           hover:border-gray-400
                           focus:outline-none focus:ring-2 focus:ring-cyan-500 focus:border-cyan-500"
                aria-label="Search for email, user ID, payout ID etc."
                value={value}
                placeholder="Name, user ID, payout ID etc."
                onChange={evt => setValue(evt.target.value)}
              />

              <Button variant="primary" type="submit" className="px-8 py-3 text-base">
                Search
              </Button>
            </div>
          </form>
        </Card.Content>
      </Card.Root>
    </div>
  )
}
